module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-1"
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("BATTLE DIGEST")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    staticClass: "bid"
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("Lessons for Today’s Leaders")]), _vm._v("         Volume 1 "), _c('span', {
    staticClass: "col1"
  }, [_vm._v("*")]), _vm._v(" Issue 8")])]), _vm._v(" "), _c('p', {
    staticClass: "title1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Early American Wars:")])]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "bid"
  }, [_vm._v("New Orleans")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Date")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_c('span', {
    staticClass: "bid"
  }, [_vm._v("January 8, 1815")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("LOCATION:")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_c('span', {
    staticClass: "bid"
  }, [_vm._v("New Orleans, Louisiana")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "subhead"
  }, [_vm._v("OPPOSING FORCES")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("American:")]), _vm._v(" 5,700 regular and militia troops commanded by Brevet Maj. Gen. Andrew Jackson. Key subordinates included Brig. Gen. David Morgan commanding 1,076 men on the West Bank of the Mississippi, and U.S. Navy Commodore Daniel Patterson supporting Jackson with two ships (USS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Carolina")]), _vm._v(" and USS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Louisiana")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("British:")]), _vm._v(" 8,000 troops commanded by Maj. Gen. Sir Edward Pakenham. Key subordinates included Maj. Gens. Sir John Keane, Sir John Lambert, and Sir Samuel Gibbs. (Adm. Sir Alexander Cochrane was the expedition’s overall commander but took little part in the ground campaign.)")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "subhead"
  }, [_vm._v("HISTORICAL SIGNIFICANCE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The War of 1812 had not gone particularly well for the United States. The British were blockading America’s coasts, damaging commerce, and thwarting any hopes for U.S. territorial gains in Canada. After two years of fighting, Americans were further humiliated when, in August of 1814, the British burned the U.S. Capitol. The people in the young republic yearned for respect. Brevet Maj. Gen. Andrew Jackson would finally give them that respect with his lopsided victory at New Orleans. Although the War of 1812 officially ended with the signing of the Treaty of Ghent two weeks prior to the battle, the commanders on the ground were unaware of it at the time. Ironically, because news of Jackson’s victory reached Washington so closely timed with word of the peace treaty, New Orleans would long be etched in the American conscience as the “victory” that ended the war. More accurately, the war was a draw. Nevertheless, the victory at New Orleans was significant enough for the U.S. to earn the respect of Britain, which never again treated America as anything less than an independent power. It would also launch the political career of a future president.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "subhead"
  }, [_vm._v("STRATEGY & MANEUVER")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Actions by the Americans")]), _vm._v(" – Britain’s heavy-handed attempts to cut off supplies to Napoleon in Europe had been pushing America toward war for years. Not only had shipping and commerce been disrupted, but since 1807 when a British warship attacked the USS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chesapeake")]), _vm._v(", American sailors had been pressed into service of the Crown. President Thomas Jefferson took the drastic step of halting all trade with England, but popular outrage continued to grow. Things reached a breaking point on 18 June 1812, when the Senate approved President James Madison’s request for a declaration of war against Great Britain.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Initially, American strategy focused on invading Canada and securing the Northwest Territory. But by 1814, after two years of lackluster results and increasing British aggressiveness, U.S. strategy turned more defensive. For the first two years of the war, British forces had not been active in the American South. Jackson was occupied against the Spanish in Florida and against the Creek Indians in the Mississippi Territory.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/img_1.jpg"
    }
  })])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-1"
    }
  }, [_vm._v("His victory at Horseshoe Bend in March 1814 effectively ended the Creek War and propelled his appointment as a Maj. Gen. in the Regular Army."), _c('sup', {
    staticClass: "sup"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn_1",
      "id": "fn1"
    }
  }, [_vm._v("1")]), _vm._v(" In May that year, Jackson assumed command of the 7th Military District, which included New Orleans. When he learned of Britain’s upcoming campaign in the Gulf, he suspected Adm. Sir Alexander Cochrane might use an overland route to take New Orleans. Working quickly, Jackson helped thwart the initial British attack at Fort Bowyer, near Mobile. He then moved his forces to New Orleans.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When Jackson arrived on 1 December, he found the defenses in poor condition. After assembling his uniquely American army comprised of Regulars, militia, two brigades of New Orleans free black men, Choctaw Indians, and even Jean Lafitte’s 800 pirates, he threw himself into preparing for the coming fight. A few weeks later, on 23 December, Jackson received surprising news from his scouts. A British force had already landed and was encamped just nine miles southeast, at Villeré Plantation in Chalmette, Louisiana. “By the Eternal,” Jackson roared, “they shall not sleep on our soil!”"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn_2",
      "id": "fn2"
    }
  }, [_vm._v("2")])]), _vm._v(" He decided to attack.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Actions by the British")]), _vm._v(" – Britain found itself in another war with America, but her forces were heavily committed against Napoleon in Europe. This forced a strategy focused on protecting Canada from American territorial designs, while trying to weaken American resolve by "), _c('a', {
    attrs: {
      "id": "VPS-2"
    }
  }, [_vm._v("crippling her commerce. Things changed with Napoleon’s defeat in 1814. As Britain was able to shift more resources to America, her strategy became more punishing. Blockades were tightened and ground troops conducted more extensive coastal raids. After the successful raids in Maryland, including the burning of the U.S. Capitol, Britain turned her attention to the Gulf of Mexico.")])]), _c('a', {
    attrs: {
      "id": "VPS-2"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/img_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Because of New Orleans’ geographical and commercial importance, Cochrane, who had led operations in the Chesapeake Bay, wanted to capture or destroy the city and complicate American control of the region and the vital Mississippi River. Initially, he planned an indirect approach, landing at Mobile Bay and marching overland to the Mississippi River and down to New Orleans. But after the force he sent to attack Mobile was repulsed in September 1814, he changed his plan.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-2"
    }
  }, [_vm._v("Cochrane planned to rendezvous with fresh troops in Jamaica and sail to the Gulf Coast before the end of 1814. With Maj. Gen. Robert Ross’s death at the Battle of North Point near Baltimore, Maj. Gen. Sir Edward Pakenham was offered command. But because Pakenham had to sail from England, Maj. Gen. Sir John Keane led the force when they departed Jamaica on 26 November. Once Cochrane’s fleet defeated the American gunboat flotilla defending Lake Borgne on 14 December, the path was clear. Keane’s men rowed ashore, and by the 23rd, they had made camp nine miles southeast of New Orleans at the Villeré Plantation, and awaited reinforcements. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "col1"
  }, [_vm._v("(")])])]), _c('a', {
    attrs: {
      "href": "#/xhtml/#map1"
    }
  }, [_vm._v("Map 1")]), _vm._v(")")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "subhead"
  }, [_vm._v("TACTICS OF THE BATTLE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Battle of New Orleans was the last of four separate engagements between the two forces over the span of two weeks. In this final twohour assault, the British conducted a frontal attack against Jackson’s well-prepared defenses just south of the city. It ended in a rout of the British.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("23 December 1814 (Jackson’s spoiling attack)")]), _vm._v(" – After Jackson’s scouts found the British camp, they estimated the British strength between 1,600 and 1,800 men. Knowing this wasn’t Cochrane’s full force, Jackson chose to strike before they could assemble. That evening, he led 2,100 of his men southeast in a surprise attack.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In the early evening darkness, the USS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Carolina")]), _vm._v(" drifted into position. British sentries near the river saw the ship and assumed it was a British supply vessel. When they hailed the ship, it let loose a deafening volley of grapeshot into the nearby British camp. Confusion swept through British ranks.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Keane hesitated until Lt. Col. Sir William Thornton, of the 85th Regiment of Foot, took over and organized a counterattack. The British were unsure where the attack was coming from until American troops, wheeling two cannons, burst out of the woods. The suddenness of the attack had pushed the British regiments back, but after reforming, Thornton led a force to capture the American guns. Jackson quickly countered, rallying his men to retake them. Both sides then traded volleys in the dark, smoke-covered field until the fighting became hopelessly confused. At that point, Jackson ordered a withdrawal. American casualties were 213 with the British suffering 277."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn_3",
      "id": "fn3"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "id": "map1",
      "src": "images/map1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "box1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col"
  }, [_vm._v("Map 1: The British campaign.")])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-3"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "id": "map2",
      "src": "images/map2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "box1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col"
  }, [_vm._v("Map 2: The Battle of New Orleans.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Although the British held their position, Jackson had surprised them with his hard-fighting men. More importantly, Jackson showed the British that taking New Orleans was not going to be easy. A more cautious Keane would wait for the arrival of Pakenham and the full British force. Jackson had bought himself precious time to reinforce his defenses.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-3"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("28 December (British reconnaissance-in-force)")]), _vm._v(" – When Pakenham finally arrived on Christmas Day and looked over the terrain, his first reaction was to re-embark his army and find a better approach. But Cochrane, confident that American militia would melt before English bayonets, convinced him to stay. "), _c('sup', {
    staticClass: "sup"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn_4",
      "id": "fn4"
    }
  }, [_vm._v("4")]), _vm._v(" Pakenham’s next move was to conduct a reconnaissance-in-force of Jackson’s position to allow his engineers and artillerymen to gauge the strength of American defenses.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On the 28th, British forces advanced. Keane took a column along the river levee, while Maj. Gen. Sir Samuel Gibbs took a column through the cypress swamp to the east. When the British came into sight– still 700 yards from Jackson’s defensive position–they were hit with punishing artillery fire. The British replied with cannon and rockets of their own, even targeting the USS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Louisiana")]), _vm._v(", which had joined the battle from the Mississippi River. As American fire concentrated against Keane’s column, Gibbs managed to get close to the American line. But when Pakenham ordered his artillery to dig in to support Gibbs, the high water table prevented it. Unaware of Gibbs’ success, Pakenham ordered a retreat to await more troops and artillery.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 January 1815 (artillery duel)")]), _vm._v(" – Pakenham planned to degrade Jackson’s defenses prior to another assault. After spending a few days emplacing more guns, he opened fire on the morning of 1 January. American guns quickly answered in an artillery duel that raged for three hours. Pakenham, however, ran low on ammunition and was forced to cease fire and suspend his planned follow-up infantry attack. Besides a few damaged guns on each side, the artillery duel was inconsequential. It did, however, bolster the morale of the American defenders, who assumed they won the exchange. On the British side, morale took a turn for the worse. The dogged Americans weren’t breaking.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("8 January (Battle of New Orleans)")]), _vm._v(" – After his initial spoiling attack, Jackson used his time well. Using the natural barrier of the "), _c('a', {
    attrs: {
      "id": "VPS-4"
    }
  }, [_vm._v("dry Rodriguez Canal south of the city, which ran from the river to the swamp, Jackson built a defensive line–dubbed “Line Jackson.” Behind the ditch, Jackson erected earthworks high enough to require scaling ladders, and placed 3,500 defenders along its length, with another 1,000 in reserve. He even emplaced supporting artillery across the river. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "col1"
  }, [_vm._v("(")])])]), _c('a', {
    attrs: {
      "href": "#/xhtml/#map2"
    }
  }, [_vm._v("Map 2")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pakenham, meanwhile, spent the week awaiting reinforcements and preparing for another assault. His plan was to send Thornton’s force across the river at night to capture enemy guns and turn them into Jackson’s flank before initiating his predawn attack. Gibbs would lead the main effort, attacking the American left flank along the swamp line, while Keane would lead a supporting attack against Jackson’s right along the river. Yet, despite the supporting attacks, Pakenham’s plan was essentially a direct assault on Jackson’s prepared defensive position. It would prove costly.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Things didn’t start well for the British. A lack of boats, combined with collapsing dams in the trenches that had been dug to launch the boats, prevented Thornton from getting into position before the main assault. Compounding the problem, the 44th Regiment–the unit assigned to carry the fascines and ladders for Gibbs’ troops to negotiate the ditch and parapets– misunderstood their orders and left them behind. By the time the 44th retrieved the equipment, it was already dawn. Considering these developments, Pakenham’s officers urged him to cancel the attack. But Pakenham wouldn’t be dissuaded.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Just after dawn, he ordered the advance. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "col1"
  }, [_vm._v("("), _c('a', {
    attrs: {
      "href": "#/xhtml/#map2"
    }
  }, [_vm._v("Map 2")]), _vm._v(")")])]), _vm._v(" Redcoats moved forward under the serendipitous cover of a heavy fog. Unfortunately for the attackers, the fog lifted when they were still more than 500 yards from Line Jackson. American cannon and grapeshot tore through the now-exposed British ranks. Redcoats struggled forward through the devastating fire only to be hit by another salvo, this time from American infantry at 200 yards. Throughout the assault, Jackson adjusted his lines, shouting “Give it to ’em, boys! Let’s finish the business today!”"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn_5",
      "id": "fn5"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Amid the chaos, the British troops carrying the ladders dropped them to return fire over the heads of their own soldiers. Minutes later, they were running for the rear. Gibbs tried to intervene but was struck down by American fire. Pakenham saw what was happening and moved up to admonish his men. “Remember you are British soldiers!”"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn_6",
      "id": "fn6"
    }
  }, [_vm._v("6")])]), _vm._v(" he yelled. Seconds later, he too was killed by American fire. Across the field, Keane also lay wounded, though his men continued the attack. Command passed to Maj. Gen. Sir John Lambert, who was leading the reserve.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Despite the carnage, British troops fought bravely. Some of Keane’s men reached the American battery closest to the river, but the unsupported attack was driven back. Gibbs’ column on the British right got close to the American line, but suffered horribly from grapeshot at ranges as close as 50 yards.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As the fighting raged on, Thornton had succeeded in taking the American gun positions across the river, but it was too late. Amid the mounting British casualties, Lambert called off the attack. The mighty British army limped away to the east, while the diverse line of Americans erupted in cheers.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Battle of New Orleans was over in just two hours. Britain had suffered over 2,000 casualties (291 dead, 1,262 wounded, and 482 prisoners"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn_7",
      "id": "fn7"
    }
  }, [_vm._v("7")])]), _vm._v("), making it one of the most lopsided defeats in British history. American casualties, by contrast, totaled just over 50 (7 dead and 6 wounded at Line Jackson, plus a few dozen more on the west bank).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("While the battle didn’t change the outcome of the war, it was a significant victory for the pride and morale of the United States. After more than two years of struggle and disappointment, American confidence had been restored along the banks of the Mississippi River. And the man who made it possible, Andrew Jackson, would be celebrated across the country and ultimately catapulted to the presidency.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/img3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "box1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "col"
  }, [_vm._v("“Battle of New Orleans” by American painter Edward Percy Moran, 1910.")])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-5"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "subhead"
  }, [_vm._v("LESSONS LEARNED")])]), _vm._v(" "), _c('p', {
    staticClass: "subhead1"
  }, [_vm._v("Strategic/Operational:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1) Strategy")]), _vm._v(" – British strategy in the Gulf was an extension of their larger strategy to degrade the American will to continue the war by punishing her population with naval-supported attacks and raids along the coasts. By attacking in the south, Britain also hoped to take pressure away from the northern theater and U.S. efforts to acquire Canadian territory. This strategy had produced results in the Chesapeake Bay and elsewhere, but in New Orleans, Cochrane’s plan for an indirect approach, which may have given him an advantage, changed to a direct approach after he was blunted in Mobile. This allowed Jackson to prepare for the more predictable attack from the south. Compounding his problems, Pakenham’s poor tactical plan–heavily influenced by Cochrane–crumbled in the face of the smart, determined, and tenacious Jackson.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2) British Failure to Maneuver")]), _vm._v(" – Because Pakenham failed to properly maneuver his forces, he ceded a significant advantage to the outnumbered Jackson. Ironically, Pakenham’s first instinct was the correct one. Dissatisfied with his initial position, he wanted to move to a more advantageous one. This is the essence of maneuver. Unfortunately, Cochrane cajoled him into remaining, which allowed Jackson to dictate the location of the fight on terrain favorable to him. Even more surprising, Pakenham chose a frontal assault on open terrain against a prepared defensive position. He even stuck with his plan despite the absence of Thornton’s enfilading position across the river. Likely blinded by overconfidence, Pakenham not only underestimated the strength of the well-prepared Line Jackson, but he also failed to properly synchronize the one thing that could have changed his fortunes–Thornton’s supporting attack on the west side of the river. As a result, the final engagement on 8 January would go down in history as one of the more ill-advised attacks by a battlefield commander.")]), _vm._v(" "), _c('p', {
    staticClass: "subhead1"
  }, [_vm._v("Tactical:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1) Mass")]), _vm._v(" – British forces failed to mass their superior numbers at any decisive point. While the combined British naval and land forces heavily outmatched the corresponding American forces in the New Orleans area, Pakenham failed to synchronize these forces to take advantage of it. Surprisingly, given Jackson’s effective use of his limited naval assets, Pakenham failed to use his own superior naval strength as anything other than transport ships. Jackson, on the other hand, despite inferior numbers, effectively massed his forces where they had the greatest effect. Pakenham cooperated by attacking into the one area where Jackson could best mass his fires– directly in front of his Line Jackson.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2) British Overconfidence")]), _vm._v(" – In the year prior to New Orleans, the British experienced a series of victories over American forces in both Canada and along the American east coast. By leveraging their well-trained army with support from the sea, they seized and retained the initiative. Cochrane fully expected this success to continue in the Gulf, to the point of overruling Pakenham’s desire to change to a better attack location, but his overconfidence was ill-advised against this particular foe. Jackson’s active leadership, skilled tactics, and effective use of terrain changed the equation. British leaders failed to give him and his “amateur” army the respect they deserved. Expecting the bravery and discipline of British troops to overcome significant tactical disadvantages was a mistake born of overconfidence.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3) British Logistical Failures")]), _vm._v(" – Pakenham’s failure to coordinate the logistical aspects of his plan contributed to his defeat. Several examples illustrate the point. The British never took the time to build adequate artillery positions or ammunition resupply roads before the battle. This made it difficult to emplace guns and bring in ammunition when needed. During the artillery duel, insufficient ammunition was stockpiled forward. This forced the attack to be called off before any real damage was done to Jackson’s defensive position. It also reinforced the notion that the Americans had “won.” Leading up to the final assault, insufficient numbers of boats were available to get Thornton’s force across the river in time for the attack. In addition, the regiment assigned the crucial task of bringing assault ladders and fascines forgot them and had to go back. Taken together, these logistics miscues failed to degrade Jackson’s position, delayed the crucial supporting attack from across the river, and prevented any serious chance at breaching Jackson’s line.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4) Jackson’s Leadership")]), _vm._v(" – Jackson was a smart, aggressive, offense-minded officer who took those skills into the defense of New Orleans. By reacting quickly to British movements with his initial spoiling attack, he gained the initiative and disrupted British preparations. He also gained valuable time to improve his Line Jackson. When the British launched their reconnaissance-in-force, Jackson made important adjustments and reinforced weak points in his defenses. Even after the artillery duel, he continued to adjust, placing a force on the west bank to provide flanking fires. Jackson also understood his troops and used it to his advantage. He knew that his new recruits and militia would perform better behind entrenched fortifications. To capitalize on this, he built a solid defensive position further stiffened by artillery. Lastly, Jackson used his strong command presence and personal example to inspire his men. When the final assault came, Jackson displayed energy, determination, and confidence. Like the Duke of Wellington would do at Waterloo five months later, Jackson appeared where he was most needed, shared the danger, and provided needed encouragement to his men.")])]), _c('div', {
    staticClass: "box"
  }, [_c('a', {
    attrs: {
      "id": "VPS-5"
    }
  }), _c('p', {
    staticClass: "noindent1d"
  }, [_c('a', {
    attrs: {
      "id": "VPS-5"
    }
  }, [_vm._v("This issue of Battle Digest™ was written by military officer and historian "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Christopher Miskimon")]), _vm._v(" for the exclusive use of Trinsicore, LLC. Battle Digest (TM) is a trademark of Trinsicore, LLC. The contents of this publication are copyrighted by Trinsicore, LLC, except as indicated in ‘Endnotes, Maps, and Images.’ All rights are reserved. No part of this publication may be reproduced or transmitted in any form, or by any means, without the prior written permission of Trinsicore, LLC, except for short passages used for the purposes of review. To request copies of this, or other issues, please visit "), _c('span', {
    staticClass: "weblink"
  })]), _c('a', {
    attrs: {
      "href": "http://www.BattleDigest.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.BattleDigest.com")])]), _c('span', {
    staticClass: "bold"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_c('a', {
    attrs: {
      "href": "http://www.BattleDigest.com",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "middle",
    attrs: {
      "alt": "image",
      "src": "images/img5.jpg"
    }
  })])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-6"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Last_page.jpg"
    }
  })])]), _c('div', {
    staticClass: "right"
  }, [_c('a', {
    attrs: {
      "id": "VPS-6"
    }
  }), _c('a', {
    attrs: {
      "href": "http://www.facebook.com",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/fb.jpg"
    }
  })]), _c('a', {
    attrs: {
      "href": "http://www.twitter.com",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/twitter.jpg"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.instagram.com",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/insta.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Endnotes, Maps, and Images")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Endnotes:")]), _vm._v(" ("), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn1",
      "id": "fn_1"
    }
  }, [_vm._v("1")]), _vm._v(") "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("American Military History")]), _vm._v(" (Center of Military History, Washington, D.C., 1989), 137. ("), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn2",
      "id": "fn_2"
    }
  }, [_vm._v("2")]), _vm._v(") Allan R. Millett and Peter Maslowski. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("For the Common Defense: A Military History of the United States of America")]), _vm._v(" (The Free Press, New York, NY, 1984), 112. ("), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn3",
      "id": "fn_3"
    }
  }, [_vm._v("3")]), _vm._v(") Lt. Col. Matthew B. Dale. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Staff Ride Handbook for the Battles of New Orleans, 23 December 1814 – 8 January 1815")]), _vm._v(" (Combat Studies Institute Press, US Army, Fort Leavenworth, KS, 2015), 87. ("), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn4",
      "id": "fn_4"
    }
  }, [_vm._v("4")]), _vm._v(") Robert V. Remeni. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Battle of New Orleans")]), _vm._v(" (Penguin Putnam Press, New York, NY, 1999), 89. ("), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn5",
      "id": "fn_5"
    }
  }, [_vm._v("5")]), _vm._v(") Ibid., 145. ("), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn6",
      "id": "fn_6"
    }
  }, [_vm._v("6")]), _vm._v(") Blaine Taylor. Andrew Jackson and the Battle of New Orleans (Warfare History Network, McLean, VA, 17 July 2015). ("), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn7",
      "id": "fn_7"
    }
  }, [_vm._v("7")]), _vm._v(") Lt. Col. Matthew B. Dale. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Staff Ride Handbook for the Battles of New Orleans, 23 December 1814 – 8 January 1815")]), _vm._v(" (Combat Studies Institute Press, US Army, Fort Leavenworth, KS, 2015), 166. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Maps:")]), _vm._v(" Courtesy of USMA Department of History. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Images:")]), _vm._v(" Jackson, Smithsonian Museum [Public Domain]. Pakenham, by Martin Cregan, 1827 [Public Domain]. The Battle of New Orleans, by Edward Percy Moran, Library of Congress [Public Domain]. The American Soldier-1781 [Public Domain], via Wikimedia Commons. Statue of Andrew Jackson in Washington DC [Public Domain].")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b6d36ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/001_Chapter_1.vue
// module id = 57
// module chunks = 0